import Footer from "../../components/footer/footer";
import Header from "../../components/header/header";

import { Link } from "react-router-dom";
import ButtonOne from "../../components/buttons/buttonOne";


export default function RoboticKit () {
    const items = [
         {
            name: "Cortex Robotics Dev Board",
            title: "Standard Edition: For everyone",
            cost: "69",
            image: "/images/shop/cortex.JPG",
            link: "https://shop.takamorirobot.com/products/h-i-r-o-model-tr-01-a-kit",
        },
        {
            name: "H.I.R.O. Model TR-01-A Kit",
            title: "Standard Edition: For everyone",
            cost: "199",
            image: "/images/shop/hiromodeltr01kit.webp",
            link: "https://shop.takamorirobot.com/products/h-i-r-o-model-tr-01-a-kit",
        },
        
        {
            name: "Zero to H.I.R.O. Exploration Kit",
            title: "Standard Edition: For everyone",
            cost: "249",
            image: "/images/shop/zerotohirokit.webp",
            link: "https://shop.takamorirobot.com/products/zero-to-h-i-r-o-exploration-kit",
        }
    ];
    
    return (
        <div className="flex flex-col items-center justify-center w-full h-full">
            <Header />
                <div className="flex flex-col w-[90%] md:w-[80%] lg:w-[60%] min-h-screen justify-center md:justify-start gap-y-[1rem] mt-[5rem] overflow-hidden">
                    <h1 className="font-bold text-2xl text-center sm:text-start">H.I.R.O. - Model TR-01-A</h1>
                    <h2 className="font-semi bold text-md text-center sm:text-start text-[#455ACC]">The New Standard in Rapid Robotics Prototyping</h2>
                    
                    {/* Kickstarter Shop Grid */}
                    <div className="flex flex-wrap justify-center sm:justify-start gap-y-[5rem] gap-x-[5rem]">           
                        {items.map((items, index) => (
                            <a
                                key={index}
                                href={items.link}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="block w-[20rem] group"
                            >
                                <p className="font-semibold text-sm my-[0.2rem]">{items.title}</p>
                                {/* Card */}
                                <div key={index} className="flex flex-col items-start">
                                    <img
                                        src={items.image}
                                        alt={items.name}
                                        className="w-[120%] h-auto rounded-xl object-cover"
                                    />
                                    <div className="flex flex-col sm:flex-row mt-[1rem] gap-x-[1rem]">
                                        <div className="flex flex-col">
                                            <p className="text-sm font-semibold text-gray-700 group-hover:underline">{items.name}</p>
                                        </div>
                                        <Link to={items.link} target="_blank" aria-label="Learn more about our beginner robotics course and engineering kit">
                                            <ButtonOne 
                                                bgColor="#F32047"
                                                fontSize="1rem"
                                                paddingX="1.5rem"
                                                paddingY="0.6rem"
                                                borderRadius="1.0rem"
                                            >
                                                Information
                                            </ButtonOne>
                                        </Link>
                                    </div>
                                </div>
                            </a>
                        ))}
                    </div>

                    <div className="mt-[4rem] w-full">
                        <h2 className="mb-[1rem] text-2xl font-bold">
                            D.I.Y. your Mechatronic Soul with H.I.R.O.!
                        </h2>

                        <div className="relative w-full overflow-hidden rounded-xl pb-[56.25%]">
                            <iframe
                            className="absolute left-0 top-0 h-full w-full"
                            src="https://www.youtube.com/embed/XPHEF36yj3g?si=ZS25DweAQn_m4ft"
                            title="Build your own MechSoul Tutorial Part 1"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowFullScreen
                            />
                        </div>
                    </div>
                    
                    <div className="flex flex-col w-full h-full items-center justify-center gap-y-[1rem] py-[2rem]">
                        <h2 id="design-robotics" className="xl:text-start text-center font-bold text-[35px] lg:text-[45px] w-full">
                                Go further with H.I.R.O!
                        </h2>
                        <div className="flex flex-col xl:flex-row justify-center items-center w-full xl:w-full h-full gap-x-[1rem] gap-y-[1rem]">
                            <div className="flex flex-col gap-y-[1rem] w-[full xl:w-[100%] font-semibold text-xl">
                                <p>
                                    Try H.I.R.O. - Model TR-01-A Pro! It's H.I.R.O. in dark mode with upgraded servos for more durability for a wider range of robotics applications.
                                </p>
                                <p>
                                    This kit was inspired by our mission to make robotics more accessible and engaging for students, hobbyists, and makers eager to explore the world of robotics.
                                </p>
                                <p>
                                    The new standard in D.I.Y. Robotics. 
                                    Inventory Limited
                                </p>
                                <Link to="https://shop.takamorirobot.com/products/h-i-r-o-model-tr-01-a-pro-edition" target="_blank" aria-label="Learn more about our beginner robotics course and engineering kit">
                                    <ButtonOne 
                                        position=""
                                        bgColor="#F32047"
                                    >
                                        Shop
                                    </ButtonOne>
                                </Link>
                            </div>
                            <img
                                src="/images/shop/HIRO Pro.jpg"
                                alt="H.I.R.O. - Model TR-01-A Pro Edition"
                                className="xl:w-[50%] max-w-l h-auto"
                            />
                        </div>
                    </div>

                </div>
            <Footer />
        </div>
    )
}